import Button from '@/components/base/button/button';
import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import type { InfoTopBannerVariant } from '@/features/info-top-banner/types/info-top-banner';
import { useSetCookie } from '@/hooks/use-cookies';
import { Cookie } from '@/types/storage';
import { XCircle } from '@phosphor-icons/react';
import { clsx } from 'clsx';

interface Props {
  handleClose: () => void;
  variant: InfoTopBannerVariant;
}

const variants = {
  black: 'group-hover/close:fill-icon group-focus/close:fill-icon',
  red: 'group-hover/close:fill-brand group-focus/close:fill-brand',
};

export const CloseBanner = ({ handleClose, variant = 'black' }: Props) => {
  const setCookie = useSetCookie();
  const onCloseBanner = () => {
    const expirationDate = new Date();
    expirationDate.setHours(expirationDate.getHours() + 12);
    setCookie(Cookie.IS_TOP_BAR_CLOSED, true, {
      expires: expirationDate,
    });

    handleClose();
  };

  return (
    <Button
      onClick={onCloseBanner}
      variant="tertiary-no-frame"
      size="small"
      className="group/close w-clickable-minimum"
    >
      <PhosphorIcon
        Icon={XCircle}
        className={clsx('icon-s fill-main', variants[variant])}
      />
    </Button>
  );
};
